import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

// experience images
import skylark from '../images/skylark.png'
import juniper from '../images/juniper.png'
import iop from '../images/iop.png'
import elsevier from '../images/elsevier.png'
import upes from '../images/upes.jpg'
import procedia from '../images/procedia.png'
import ieee from '../images/ieee.png'
import red_hat from '../images/red_hat.png'
import wys from '../images/wys/logo.jpg'

// Research paper images
import etlogo from '../images/logoooo.png'
import seedlogo from '../images/seed.png'
import mm from '../images/mm.png'
import snlogo from '../images/SN/icon.png'
import natourslogo from '../images/Natours/icon.png'
import VanillaTilt from 'vanilla-tilt'

import { Skillsdata } from '../Skillsdata'

// Progress bar
import ProgressBar from '@ramonak/react-progress-bar'

// Projectinfo
import { Link } from 'react-router-dom'

// Animations
import { motion } from 'framer-motion'
import { Fade, FadeLine, pageAnimation } from './Animation'

const Skills = () => {
    //   const stringPathID = props.id.toString();
    function Tilt(props) {
        const { options, ...rest } = props
        const tilt = useRef(null)

        useEffect(() => {
            const tiltNode = tilt.current
            // Check if the screen width is greater than 768px (or your desired breakpoint)
            if (window.innerWidth > 768) {
                VanillaTilt.init(tilt.current, options)
            }
            // Cleanup on unmount
            return () => {
                if (tiltNode && tiltNode.vanillaTilt) {
                    tiltNode.vanillaTilt.destroy()
                }
            }
        }, [options])

        // We only care about the options, not the other props, hence ref is assigned to tile and rest is just signifies the attributes of the tag ,like the className box below or style etc.
        return (
            <div
                ref={tilt}
                {...rest}
                // style={{ backdropFilter: "blur(5px)" }}
            />
        )
    }

    const options = {
        scale: 1.1,
        speed: 800,
        max: 30,
        perspective: 1000,
        reset: true,
    }

    //   TOGGLE HANDLERS
    // ML SKILLS
    // const [sweShow, setSWEShow] = useState(false)
    const [webShow, setWebShow] = useState(false)
    const [devopsShow, setDevopsShow] = useState(false)

    // const sweHandler = () => {
    //     setSWEShow(!sweShow)
    // }
    const webHandler = () => {
        setWebShow(!webShow)
    }
    const devopsHandler = () => {
        setDevopsShow(!devopsShow)
    }

    const showModal = (callback) => {
        callback(true)
    }

    const handleClose = (callback) => {
        callback(false)
    }

    // Modal
    const [isJuniperModalOpen, setIsJuniperModalOpen] = useState(false)
    const [isSkylarkModalOpen, setIsSkylarkModalOpen] = useState(false)
    const [isRedHatModalOpen, setIsRedHatModalOpen] = useState(false)
    const [isICMLDEModalOpen, setIsICMLDEModalOpen] = useState(false)
    const [isIOPModalOpen, setIsIOPModalOpen] = useState(false)

    return (
        <div>
            {isJuniperModalOpen && (
                <CustomJuniperModal
                    isVisible={isJuniperModalOpen}
                    onClose={() => handleClose(setIsJuniperModalOpen)}
                />
            )}
            {isSkylarkModalOpen && (
                <CustomSkylarkModal
                    isVisible={isSkylarkModalOpen}
                    onClose={() => handleClose(setIsSkylarkModalOpen)}
                />
            )}
            {isICMLDEModalOpen && (
                <CustomICMLDEModal
                    isVisible={isICMLDEModalOpen}
                    onClose={() => handleClose(setIsICMLDEModalOpen)}
                />
            )}
            {isIOPModalOpen && (
                <CustomIOPModal
                    isVisible={isIOPModalOpen}
                    onClose={() => handleClose(setIsIOPModalOpen)}
                />
            )}
            {isRedHatModalOpen && (
                <CustomRedHatModal
                    isVisible={isRedHatModalOpen}
                    onClose={() => handleClose(setIsRedHatModalOpen)}
                />
            )}
            <SkillsContainer
                variants={pageAnimation}
                initial="hidden"
                animate="show"
                exit="exit"
            >
                <Intro>
                    <motion.h1
                        variants={FadeLine}
                        style={{
                            fontSize: '3rem',
                            fontWeight: 'bolder',
                            marginBottom: '2rem',
                        }}
                    >
                        My Experience
                    </motion.h1>
                </Intro>
                <SkillsFlex>
                    <Cards style={{ marginBottom: '6rem' }}>
                        <Tilt className="box" options={options}>
                            <Card
                                onClick={() => showModal(setIsRedHatModalOpen)}
                                makePointer
                            >
                                <Content>
                                    <img
                                        src={red_hat}
                                        style={{
                                            width: '150px',
                                            height: '150px',
                                        }}
                                        alt="logo"
                                    />
                                    <p>Red Hat</p>
                                </Content>
                            </Card>
                        </Tilt>
                        <Tilt className="box" options={options}>
                            <Card
                                onClick={() => showModal(setIsJuniperModalOpen)}
                                makePointer
                            >
                                <Content>
                                    <img
                                        style={{
                                            width: '150px',
                                            height: '150px',
                                        }}
                                        src={juniper}
                                        alt="logo"
                                    />
                                    <p>Juniper Networks</p>
                                </Content>
                            </Card>
                        </Tilt>
                        <Tilt className="box" options={options}>
                            <Card
                                onClick={() => showModal(setIsSkylarkModalOpen)}
                                makePointer
                            >
                                <Content>
                                    <img
                                        src={skylark}
                                        style={{
                                            width: '150px',
                                            height: '150px',
                                        }}
                                        alt="logo"
                                    />
                                    <p>Skylark Drones</p>
                                </Content>
                            </Card>
                        </Tilt>
                    </Cards>
                </SkillsFlex>
                <Intro>
                    <motion.h1
                        variants={FadeLine}
                        style={{
                            fontSize: '3rem',
                            fontWeight: 'bolder',
                            marginBottom: '2rem',
                        }}
                    >
                        My International Conference Research Papers
                    </motion.h1>
                </Intro>
                <SkillsFlex>
                    <Cards style={{ marginBottom: '6rem' }}>
                        <Tilt className="box" options={options}>
                            <Card
                                makePointer
                                onClick={() => showModal(setIsICMLDEModalOpen)}
                            >
                                <Content>
                                    <img
                                        style={{
                                            width: '150px',
                                            height: '150px',
                                        }}
                                        src={upes}
                                        alt="logo"
                                    />
                                    <p>
                                        UPES - ICMLDE'23 - Elsevier - Procedia
                                        Journal of CS
                                    </p>
                                </Content>
                            </Card>
                        </Tilt>
                        <Tilt className="box" options={options}>
                            <Card
                                makePointer
                                onClick={() => showModal(setIsIOPModalOpen)}
                            >
                                <Content>
                                    <img
                                        src={iop}
                                        style={{
                                            width: '200px',
                                            height: '200px',
                                        }}
                                        alt="logo"
                                    />
                                    <p>
                                        AICECS'23 - IOP Science - Journal of
                                        Physics
                                    </p>
                                </Content>
                            </Card>
                        </Tilt>
                    </Cards>
                </SkillsFlex>
                <Intro>
                    <motion.h1
                        variants={FadeLine}
                        style={{
                            fontSize: '3rem',
                            fontWeight: 'bolder',
                            marginBottom: '2rem',
                        }}
                    >
                        My Projects
                    </motion.h1>
                </Intro>
                <SkillsFlex>
                    <Cards style={{ marginBottom: '6rem' }}>
                        <Tilt className="box" options={options}>
                            <Card>
                                <Content>
                                    <Link
                                        to="/projects/watch-your-spend"
                                        style={{ textDecoration: 'none' }}
                                    >
                                        <img
                                            style={{
                                                width: '180px',
                                                height: '180px',
                                            }}
                                            src={wys}
                                            alt="logo"
                                        />
                                        <p>Watch Your Spend</p>
                                    </Link>
                                </Content>
                            </Card>
                        </Tilt>
                        <Tilt className="box" options={options}>
                            <Card>
                                <Content>
                                    <Link
                                        to="/projects/graphin-tunes"
                                        style={{ textDecoration: 'none' }}
                                    >
                                        <img
                                            style={{
                                                width: '180px',
                                                height: '180px',
                                            }}
                                            src={mm}
                                            alt="logo"
                                        />
                                        <p>Graphin Tunes</p>
                                    </Link>
                                </Content>
                            </Card>
                        </Tilt>
                        <Tilt className="box" options={options}>
                            <Card>
                                <Content>
                                    <Link
                                        to="/projects/examtantra"
                                        style={{ textDecoration: 'none' }}
                                    >
                                        <img
                                            style={{
                                                width: '180px',
                                                height: '180px',
                                            }}
                                            src={etlogo}
                                            alt="logo"
                                        />
                                        <p>Exam Tantra</p>
                                    </Link>
                                </Content>
                            </Card>
                        </Tilt>
                        <Tilt className="box" options={options}>
                            <Link
                                to="/projects/natours"
                                style={{ textDecoration: 'none' }}
                            >
                                <Card>
                                    <Content>
                                        <img
                                            src={natourslogo}
                                            style={{
                                                width: '250px',
                                                height: '250px',
                                            }}
                                            alt="logo"
                                        />
                                        <p>Natours</p>
                                    </Content>
                                </Card>
                            </Link>
                        </Tilt>
                        <Tilt className="box" options={options}>
                            <Link
                                to="/projects/seed"
                                style={{ textDecoration: 'none' }}
                            >
                                <Card>
                                    <Content>
                                        <img
                                            src={seedlogo}
                                            style={{
                                                width: '250px',
                                                height: '250px',
                                            }}
                                            alt="logo"
                                        />
                                        <p>Seed</p>
                                    </Content>
                                </Card>
                            </Link>
                        </Tilt>
                        <Tilt className="box" options={options}>
                            <Link
                                to="/projects/serenity-now"
                                style={{ textDecoration: 'none' }}
                            >
                                <Card>
                                    <Content>
                                        <img
                                            src={snlogo}
                                            style={{
                                                width: '250px',
                                                height: '250px',
                                            }}
                                            alt="logo"
                                        />
                                        <p>Serenity Now</p>
                                    </Content>
                                </Card>
                            </Link>
                        </Tilt>
                    </Cards>
                </SkillsFlex>
                <Intro>
                    <motion.h1
                        variants={FadeLine}
                        style={{ fontSize: '3rem', fontWeight: 'bolder' }}
                    >
                        My Skills
                    </motion.h1>
                    <motion.h2
                        variants={Fade}
                        style={{
                            fontSize: '2.2rem',
                            color: '#44bd8c',
                            textAlign: 'center',
                            margin: '2rem 0rem',
                            fontWeight: 'bold',
                        }}
                    >
                        Software Engineering
                    </motion.h2>
                </Intro>
                <SkillsFlex>
                    <Cards>
                        {/* The props are className(rest)  and options which is destructured as props.*/}
                        {true
                            ? Skillsdata()[0].skills.map((skill) => {
                                  return (
                                      <Tilt
                                          key={skill.title}
                                          className="box"
                                          options={options}
                                      >
                                          <Card
                                              initial={{ opacity: 0 }}
                                              animate={{ opacity: 1 }}
                                          >
                                              <Content>
                                                  <img
                                                      src={skill.mainImg}
                                                      alt=""
                                                  />
                                                  <p>{skill.title}</p>
                                                  <ProgressBar
                                                      completed={
                                                          skill.completed
                                                      }
                                                      animateOnRender={true}
                                                      isLabelVisible={false}
                                                      padding="0"
                                                      height="15"
                                                      bgColor="#44bd8c"
                                                  />
                                              </Content>
                                          </Card>
                                      </Tilt>
                                  )
                              })
                            : Skillsdata()[0]
                                  .skills.slice(0, 4)
                                  .map((skill) => {
                                      return (
                                          <Tilt
                                              key={skill.title}
                                              className="box"
                                              options={options}
                                          >
                                              <Card
                                                  initial={{ opacity: 0 }}
                                                  animate={{ opacity: 1 }}
                                              >
                                                  <Content>
                                                      <img
                                                          src={skill.mainImg}
                                                          alt=""
                                                      />
                                                      <p>{skill.title}</p>
                                                      <ProgressBar
                                                          completed={
                                                              skill.completed
                                                          }
                                                          animateOnRender={true}
                                                          isLabelVisible={false}
                                                          padding="0"
                                                          height="15"
                                                          bgColor="#44bd8c"
                                                      />
                                                  </Content>
                                              </Card>
                                          </Tilt>
                                      )
                                  })}
                    </Cards>
                </SkillsFlex>
                <SkillsFlex>
                    {/* <motion.h6 variants={Fade} onClick={mlHandler}>
                        Show {sweShow ? ' less' : 'more'}
                    </motion.h6> */}
                </SkillsFlex>
                <Intro>
                    <motion.h2
                        variants={Fade}
                        style={{
                            fontSize: '2.2rem',
                            color: '#44bd8c',
                            textAlign: 'center',
                            margin: '2rem 0rem',
                            fontWeight: 'bold',
                        }}
                    >
                        Full-Stack Web Development
                    </motion.h2>
                </Intro>
                <SkillsFlex>
                    <Cards>
                        {webShow
                            ? Skillsdata()[1].skills.map((skill) => {
                                  return (
                                      <Tilt
                                          key={skill.title}
                                          className="box"
                                          options={options}
                                      >
                                          <Card
                                              initial={{ opacity: 0 }}
                                              animate={{ opacity: 1 }}
                                          >
                                              <Content>
                                                  <img
                                                      src={skill.mainImg}
                                                      alt="mainimg"
                                                  />
                                                  <p>{skill.title}</p>
                                                  <ProgressBar
                                                      completed={
                                                          skill.completed
                                                      }
                                                      animateOnRender={true}
                                                      isLabelVisible={false}
                                                      padding="0"
                                                      height="15"
                                                      bgColor="#44bd8c"
                                                  />
                                              </Content>
                                          </Card>
                                      </Tilt>
                                  )
                              })
                            : Skillsdata()[1]
                                  .skills.slice(0, 4)
                                  .map((skill) => {
                                      return (
                                          <Tilt
                                              key={skill.title}
                                              className="box"
                                              options={options}
                                          >
                                              <Card
                                                  initial={{ opacity: 0 }}
                                                  animate={{ opacity: 1 }}
                                              >
                                                  <Content>
                                                      <img
                                                          src={skill.mainImg}
                                                          alt=""
                                                      />
                                                      <p>{skill.title}</p>
                                                      <ProgressBar
                                                          completed={
                                                              skill.completed
                                                          }
                                                          animateOnRender={true}
                                                          isLabelVisible={false}
                                                          padding="0"
                                                          height="15"
                                                          bgColor="#44bd8c"
                                                      />
                                                  </Content>
                                              </Card>
                                          </Tilt>
                                      )
                                  })}
                    </Cards>
                </SkillsFlex>
                <SkillsFlex linkMargin>
                    <motion.h6 variants={Fade} onClick={webHandler}>
                        Show {webShow ? ' less' : 'more'}
                    </motion.h6>
                </SkillsFlex>
                <Intro>
                    <motion.h2
                        variants={Fade}
                        style={{
                            fontSize: '2.2rem',
                            color: '#44bd8c',
                            textAlign: 'center',
                            margin: '2rem 0rem',
                            fontWeight: 'bold',
                        }}
                    >
                        DevOps, CI/CD and Testing
                    </motion.h2>
                </Intro>
                <SkillsFlex>
                    <Cards>
                        {devopsShow
                            ? Skillsdata()[2].skills.map((skill) => {
                                  return (
                                      <Tilt
                                          key={skill.title}
                                          className="box"
                                          options={options}
                                      >
                                          <Card
                                              initial={{ opacity: 0 }}
                                              animate={{ opacity: 1 }}
                                          >
                                              <Content>
                                                  <img
                                                      src={skill.mainImg}
                                                      alt="mainimg"
                                                  />
                                                  <p>{skill.title}</p>
                                                  <ProgressBar
                                                      completed={
                                                          skill.completed
                                                      }
                                                      animateOnRender={true}
                                                      isLabelVisible={false}
                                                      padding="0"
                                                      height="15"
                                                      bgColor="#44bd8c"
                                                  />
                                              </Content>
                                          </Card>
                                      </Tilt>
                                  )
                              })
                            : Skillsdata()[2]
                                  .skills.slice(0, 4)
                                  .map((skill) => {
                                      return (
                                          <Tilt
                                              key={skill.title}
                                              className="box"
                                              options={options}
                                          >
                                              <Card
                                                  initial={{ opacity: 0 }}
                                                  animate={{ opacity: 1 }}
                                              >
                                                  <Content>
                                                      <img
                                                          src={skill.mainImg}
                                                          alt=""
                                                      />
                                                      <p>{skill.title}</p>
                                                      <ProgressBar
                                                          completed={
                                                              skill.completed
                                                          }
                                                          animateOnRender={true}
                                                          isLabelVisible={false}
                                                          padding="0"
                                                          height="15"
                                                          bgColor="#44bd8c"
                                                      />
                                                  </Content>
                                              </Card>
                                          </Tilt>
                                      )
                                  })}
                    </Cards>
                </SkillsFlex>
                <SkillsFlex>
                    <motion.h6 variants={Fade} onClick={devopsHandler}>
                        Show {devopsShow ? ' less' : 'more'}
                    </motion.h6>
                </SkillsFlex>
                <Intro>
                    <motion.h2
                        variants={Fade}
                        style={{
                            fontSize: '2.2rem',
                            color: '#44bd8c',
                            textAlign: 'center',
                            margin: '2rem 0rem',
                            fontWeight: 'bold',
                        }}
                    >
                        Machine Learning and AI
                    </motion.h2>
                </Intro>
                <SkillsFlex lastRow>
                    <Cards>
                        {Skillsdata()[3].skills.map((skill) => {
                            return (
                                <Tilt
                                    key={skill.title}
                                    className="box"
                                    options={options}
                                >
                                    <Card
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                    >
                                        <Content>
                                            <img
                                                src={skill.mainImg}
                                                alt="mainimg"
                                            />
                                            <p>{skill.title}</p>
                                            <ProgressBar
                                                completed={skill.completed}
                                                animateOnRender={true}
                                                isLabelVisible={false}
                                                padding="0"
                                                height="15"
                                                bgColor="#44bd8c"
                                            />
                                        </Content>
                                    </Card>
                                </Tilt>
                            )
                        })}
                    </Cards>
                </SkillsFlex>
            </SkillsContainer>
        </div>
    )
}

const SkillsContainer = styled(motion.div)`
    font-family: 'Quicksand', sans-serif;
    overflow-y: hidden;
    img {
        width: 200px;
        height: 200px;
        object-fit: contain;
    }
    overflow-x: hidden;
`

const Intro = styled(motion.div)`
    h1 {
        text-align: center;
        color: white;
        padding: 3rem 0rem 1rem 0rem;
        border-bottom: 1px solid white;
        width: 60%;
        margin: auto;
    }
`

const SkillsFlex = styled(motion.div)`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    margin-bottom: ${(props) => (props.lastRow ? '6rem' : '1rem')};
`

const Cards = styled(motion.div)`
    max-width: 100%;
    height: 100%;
    z-index: 1;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    @media screen and (max-width: 520px) {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
    }
`

const Card = styled(motion.div)`
    height: 380px;
    position: relative;
    border-radius: 15px;
    box-shadow: 20px 20px 50px rgba(0, 0, 0, 0.5);
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid rgba(255, 255, 255, 0.5);
    border-left: 1px solid rgba(255, 255, 255, 0.5);
    margin: 1rem;
    width: 280px;
    @media screen and (max-width: 520px) {
        width: 200px;
        height: 370px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 1rem;
    }
    cursor: ${(props) => props.makePointer && 'pointer'};
`

const Content = styled(motion.div)`
    padding: 1.2rem;
    text-align: center;
    img {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 70%;
    }
    p {
        color: white;
        font-size: 1.5rem;
        font-family: 'Quicksand', sans-serif;
        font-weight: bold;
        padding: 1.5rem 0rem;
        text-shadow: 20px 20px 40px rgba(0, 0, 0);
    }
    transition: 0.5s ease;
    @media screen and (max-width: 520px) {
        p {
            font-size: 1.5rem;
        }
    }
`

const ModalOverlay = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`

const ModalContent = styled(motion.div)`
    background: #1b1b1b;
    border-radius: 8px;
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 30px;
    padding-bottom: 30px;
    width: 90%;
    max-width: 800px;
    max-height: 90%;
    overflow-y: auto;
    color: white;

    @media (min-width: 768px) {
        width: 80%;
    }

    h2 {
        color: #23d997;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    img {
        width: 28%;
        height: auto;
        border-radius: 8px;
        margin: 20px 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
        margin: 20px 0;
    }

    ul li {
        margin-bottom: 10px;
        display: flex;
        align-items: center;

        &::before {
            content: '•';
            color: #23d997;
            font-weight: bold;
            display: inline-block;
            width: 1em;
            margin-left: -1em;
            margin-right: 0.5rem;
        }
    }

    font-size: 1.2em;

    h2 {
        font-size: 1.5em;
    }

    ul li {
        font-size: 1.2em;
    }
`

const CloseButton = styled.button`
    background-color: #23d997;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 10px 20px;
    cursor: pointer;
    font-size: 16px;
    margin-top: 20px;
    transition: background-color 0.3s;

    &:hover {
        background-color: #1b9a70;
    }
`

const PaperLink = styled.a`
    display: block;
    margin-top: 20px;
    color: #23d997;
    text-decoration: none;
    font-size: 16px;
    font-weight: bold;

    &:hover {
        text-decoration: underline;
        color: #1b9a70;
    }
`

const Authors = styled.p`
    margin-top: 20px;
    font-size: 16px;
    color: white;

    span {
        color: #23d997;
    }
`

const CustomJuniperModal = ({ isVisible, onClose }) => {
    useEffect(() => {
        if (isVisible) {
            document.body.classList.add('modal-open')
        } else {
            document.body.classList.remove('modal-open')
        }

        return () => {
            document.body.classList.remove('modal-open')
        }
    }, [isVisible])

    return (
        <ModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
        >
            <ModalContent
                initial={{ y: '-100vh' }}
                animate={{ y: 0, transition: { duration: 0.35 } }}
                exit={{ y: '100vh' }}
                onClick={(e) => e.stopPropagation()}
            >
                <h2>
                    Juniper Networks
                    <span style={{ fontSize: '16px', color: '#aaa' }}>
                        Jan 2024 - Mar 2026
                    </span>
                </h2>
                <img src={juniper} alt="Juniper Networks" />
                <ul>
                    <li>
                        Worked on sustainability for the datacenter at Juniper
                        Networks.
                    </li>
                    <li>
                        Contributed to cloud-native solutions using Kubernetes,
                        Golang, Open Telemetry and Prometheus.
                    </li>
                    <li>
                        Contributed to Golang and Java microservices for various
                        use-cases, such as retreiving power and custom metrics
                        and on-demand chassis information directly from the
                        device via Apstra (on-prem vendor-agnostic datacenter
                        platform).
                    </li>
                    <li>
                        Integration with Elastic Search, Kafka and Cassandra to
                        satisfy our requirements for data storage and retrieval.
                    </li>
                    <li>
                        Also worked with React, Redux and Typescript for
                        generating enterprise-level reports for customers.
                    </li>
                    <li>
                        End-to-end testing of UI and backend features using
                        Playwright, Jenkins and Pytest, with all test cases
                        managed by TestRail.
                    </li>
                </ul>
                <CloseButton onClick={onClose}>Close</CloseButton>
            </ModalContent>
        </ModalOverlay>
    )
}

const CustomRedHatModal = ({ isVisible, onClose }) => {
    useEffect(() => {
        if (isVisible) {
            document.body.classList.add('modal-open')
        } else {
            document.body.classList.remove('modal-open')
        }

        return () => {
            document.body.classList.remove('modal-open')
        }
    }, [isVisible])

    return (
        <ModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
        >
            <ModalContent
                initial={{ y: '-100vh' }}
                animate={{ y: 0, transition: { duration: 0.35 } }}
                exit={{ y: '100vh' }}
                onClick={(e) => e.stopPropagation()}
            >
                <h2>
                    Red Hat
                    <span style={{ fontSize: '16px', color: '#aaa' }}>
                        Apr 2026 - Present
                    </span>
                </h2>
                <img src={red_hat} alt="Red Hat" />
                <ul>
                    <li>
                        Currently working on Confidential Clusters at Red Hat.
                    </li>
                </ul>

                <CloseButton onClick={onClose}>Close</CloseButton>
            </ModalContent>
        </ModalOverlay>
    )
}

const CustomSkylarkModal = ({ isVisible, onClose }) => {
    useEffect(() => {
        if (isVisible) {
            document.body.classList.add('modal-open')
        } else {
            document.body.classList.remove('modal-open')
        }

        return () => {
            document.body.classList.remove('modal-open')
        }
    }, [isVisible])

    return (
        <ModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
        >
            <ModalContent
                initial={{ y: '-100vh' }}
                animate={{ y: 0, transition: { duration: 0.35 } }}
                exit={{ y: '100vh' }}
                onClick={(e) => e.stopPropagation()}
            >
                <h2>
                    Skylark Drones
                    <span style={{ fontSize: '16px', color: '#aaa' }}>
                        Dec 2022 - July 2023
                    </span>
                </h2>
                <img src={skylark} alt="Skylark Drones" />
                <ul>
                    <li>
                        Engineered an automated end-to-end workflow pipeline,
                        for converting rasters taken from DigitalSky to
                        polygons.
                    </li>
                    <li>
                        These polygons can be displayed on Mapbox as tiles and
                        spun up a CRON job to do this periodically every month.
                    </li>
                    <li>
                        Dockerized and deployed the application end-to-end,
                        taking into consideration coding standards to write
                        industry standard code.
                    </li>
                    <li>
                        Converted my code to a microservice and hosted images on
                        Amazon S3 and deployed the compute instance on Amazon
                        EC2.
                    </li>
                </ul>

                <CloseButton onClick={onClose}>Close</CloseButton>
            </ModalContent>
        </ModalOverlay>
    )
}

const CustomICMLDEModal = ({ isVisible, onClose }) => {
    useEffect(() => {
        if (isVisible) {
            document.body.classList.add('modal-open')
        } else {
            document.body.classList.remove('modal-open')
        }

        return () => {
            document.body.classList.remove('modal-open')
        }
    }, [isVisible])

    return (
        <ModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
        >
            <ModalContent
                initial={{ y: '-100vh' }}
                animate={{ y: 0, transition: { duration: 0.35 } }}
                exit={{ y: '100vh' }}
                onClick={(e) => e.stopPropagation()}
            >
                <h2>
                    UPES - ICMLDE'23
                    <span style={{ fontSize: '16px', color: '#aaa' }}>
                        Elsevier Indexed, Procedia Journal of Computer Science
                    </span>
                </h2>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignContent: 'center',
                        alignItems: 'center',
                        gap: '30px',
                    }}
                >
                    <img src={elsevier} alt="elsevier" />
                    <img src={procedia} alt="procedia" />
                </div>
                {/* Heading in pink for the title */}
                <h3
                    style={{
                        color: '#c562c5',
                        fontSize: '1.5rem',
                        marginTop: '1rem',
                        marginBottom: '1rem',
                    }}
                >
                    Addressing Vaccine Misinformation on Social Media by
                    leveraging Transformers and User Association Dynamics
                </h3>
                <ul>
                    <li>
                        Implemented a novel transformer-based architecture to
                        classify vaccine mis-information, using BERT and XLNET.
                    </li>
                    <li>
                        Data was scraped from Reddit and Twitter, using the
                        Twitter and PRAW API.
                    </li>
                    <li>
                        We also built a community detection algorithm, for
                        detecting clustering within the graph, using cosine
                        similarity and Jaccard Index techniques.
                    </li>
                </ul>
                <Authors>
                    <span>Authors:</span> Chirag Rao, Gautham Prabhu, Ajay
                    Kumar, Shourya Gupta, Nisha Shetty
                </Authors>
                <PaperLink
                    href="https://www.sciencedirect.com/science/article/pii/S1877050924008470"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Read the full paper here
                </PaperLink>
                <CloseButton onClick={onClose}>Close</CloseButton>
            </ModalContent>
        </ModalOverlay>
    )
}

const CustomIOPModal = ({ isVisible, onClose }) => {
    useEffect(() => {
        if (isVisible) {
            document.body.classList.add('modal-open')
        } else {
            document.body.classList.remove('modal-open')
        }

        return () => {
            document.body.classList.remove('modal-open')
        }
    }, [isVisible])

    return (
        <ModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
        >
            <ModalContent
                initial={{ y: '-100vh' }}
                animate={{ y: 0, transition: { duration: 0.35 } }}
                exit={{ y: '100vh' }}
                onClick={(e) => e.stopPropagation()}
                makeSmaller
            >
                <h2>
                    AICECS'23 - IOP Science, Journal of Physics
                    <span style={{ fontSize: '16px', color: '#aaa' }}>
                        IEEE Xplore
                    </span>
                </h2>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignContent: 'center',
                        alignItems: 'center',
                        gap: '30px',
                    }}
                >
                    <img src={iop} alt="iopscience" />
                    <img src={ieee} alt="ieee" />
                </div>
                <h3
                    style={{
                        color: '#c562c5',
                        fontSize: '1.5rem',
                        marginTop: '1rem',
                        marginBottom: '1rem',
                    }}
                >
                    Survey of the use of AI models and techniques in the
                    analysis and prediction of neuro-degenerative diseases
                </h3>
                <ul>
                    <li>
                        Implemented a novel transformer-based architecture to
                        classify vaccine mis-information, using BERT and XLNET.
                    </li>
                    <li>
                        Data was scraped from Reddit and Twitter, using the
                        Twitter and PRAW API.
                    </li>
                    <li>
                        We also built a community detection algorithm, for
                        detecting clustering within the graph, using cosine
                        similarity and Jaccard Index techniques.
                    </li>
                </ul>
                <Authors>
                    <span>Authors:</span> Srikanth Prabhu, Suryaansh Rathinam,
                    Chirag Rao, Anurag Chowdhury
                </Authors>
                <PaperLink
                    href="https://iopscience.iop.org/article/10.1088/1742-6596/2571/1/012022"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Read the full paper here
                </PaperLink>

                <CloseButton onClick={onClose}>Close</CloseButton>
            </ModalContent>
        </ModalOverlay>
    )
}

export default Skills
